import { Injectable } from "@angular/core";
import { legalLinks } from "src/app/pages/account/legal-links.config";
import { OfferRegionService } from "./offer-region.service";

/**
 * FLIP-652. The Privacy Policy and Terms of Use links for the visitor's region, so the sign-up screens
 * and the signed-in ones agree with the region the prices are shown in (OfferRegionService, FLIP-537).
 * Works before login: the region comes from the iPhone's storefront or the device's timezone.
 */
@Injectable({ providedIn: "root" })
export class LegalLinksService {
  constructor(private offerRegion: OfferRegionService) {}

  get privacyUrl(): string {
    return legalLinks(this.offerRegion.region()).privacyUrl;
  }

  get termsUrl(): string {
    return legalLinks(this.offerRegion.region()).termsUrl;
  }

  /**
   * Reads the iPhone's App Store storefront (iOS app only) so the links below follow it rather than
   * the timezone. Call from a screen's ngOnInit; the getters work without it. Never rejects.
   */
  ensure(): Promise<void> {
    return this.offerRegion.ensureStorefront();
  }
}
